var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDisplaySetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 10.8H6.00016V8.13338H5.00016V8.96672H4.00016V9.96672H5.00016V10.8ZM6.66683 9.96672H12.0002V8.96672H6.66683V9.96672ZM10.0002 8.13338H11.0002V7.30005H12.0002V6.30005H11.0002V5.46672H10.0002V8.13338ZM4.00016 7.30005H9.3335V6.30005H4.00016V7.30005ZM5.3335 14.8V13.4667H2.66683C2.30016 13.4667 1.98627 13.3362 1.72516 13.075C1.46405 12.8139 1.3335 12.5 1.3335 12.1334V4.13338C1.3335 3.76672 1.46405 3.45283 1.72516 3.19172C1.98627 2.9306 2.30016 2.80005 2.66683 2.80005H13.3335C13.7002 2.80005 14.0141 2.9306 14.2752 3.19172C14.5363 3.45283 14.6668 3.76672 14.6668 4.13338V12.1334C14.6668 12.5 14.5363 12.8139 14.2752 13.075C14.0141 13.3362 13.7002 13.4667 13.3335 13.4667H10.6668V14.8H5.3335ZM2.66683 12.1334H13.3335V4.13338H2.66683V12.1334Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisplaySetting);
export default __webpack_public_path__ + "static/media/ICON_DISPLAY_SETTING.1f1c2330ffd6925aeb883fd7fbd52f30.svg";
export { ForwardRef as ReactComponent };